import React from 'react'
import { render } from 'react-dom'
// import './index.css'
// import BrowserRouter from 'react-router-dom/BrowserRouter'
import App from './App'
// import registerServiceWorker from './registerServiceWorker'
import { ApolloClient } from 'apollo-client'
import { BatchHttpLink } from 'apollo-link-batch-http'
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory'
import { ApolloProvider } from 'react-apollo'
import { ApolloProvider as ApolloHooksProvider } from 'react-apollo-hooks'

// import './index.css'
// const clientId = process.env.REACT_APP_CLIENT_ID
const clientId = window.location.hostname
const apolloClient = new ApolloClient({
  // initialState: window.__APOLLO_STATE__,
  // networkInterface
  link: new BatchHttpLink({
    uri: process.env.REACT_APP_API_URI,
    credentials: 'include',
    headers: {
      ...(clientId && { 'X-ThaiRun-Client-ID': clientId })
    }
  }),
  cache: new InMemoryCache({
    dataIdFromObject: object => {
      if (['PropertyQuestionItems'].includes(object.__typename)) {
        return null
      }
      return defaultDataIdFromObject(object)
    }
  })
})

render(
  <ApolloProvider client={apolloClient}>
    <ApolloHooksProvider client={apolloClient}>
      <App />
    </ApolloHooksProvider>,
  </ApolloProvider>,
  document.getElementById('root')
)

// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js